import { ROOT_ID } from '@constants/common';
import { IslandProps } from '@island-runtime/types';
import { logError } from '@utils/errors';

/**
 * Reads the JSON the host page puts into `data-props` of a mount node. The
 * attribute is hand-written by the host templates, so anything missing,
 * malformed or not an object becomes `{}` instead of throwing; components then
 * pick their keys through the guarded readers in
 * `@components/islands/islandProps.utils`.
 */
export const parseDataProps = (el?: HTMLElement | null): IslandProps => {
  const raw = el?.dataset.props;

  if (!raw) {
    return {};
  }

  try {
    const props: unknown = JSON.parse(raw);

    return props && typeof props === 'object' && !Array.isArray(props)
      ? (props as IslandProps)
      : {};
  } catch (error) {
    logError(error, { source: 'parseDataProps' });

    return {};
  }
};

/**
 * Page data for the SPA: the `data-props` of its mount node, the same contract
 * the islands use. The host sends whatever it has, each page takes what it needs.
 */
export const getHostProps = (): IslandProps =>
  parseDataProps(document.getElementById(ROOT_ID));
